import { FC, ImgHTMLAttributes } from 'react';
import './Image.css';

const Image: FC<ImgHTMLAttributes<HTMLImageElement>> = ({ alt, ...props }) => {
  return (
    <img {...props} alt={alt} />
  )
}

export default Image;
